import { render, staticRenderFns } from "./NoDeepLink.vue?vue&type=template&id=5b1645ee&scoped=true"
var script = {}
import style0 from "./NoDeepLink.vue?vue&type=style&index=0&id=5b1645ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1645ee",
  null
  
)

export default component.exports